import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';

const StatsCurrentRate = ({ rate }) => {
	if (!rate || Object.keys(rate).length === 0) {
		return null;
	}

	const jobsPerMinute = rate.jobs_per_minute || 0;
	const jobsLastMinutes = rate.jobs_last_minutes || 0;

	return (
		<Card className='shadow-sm mb-3 card-border'>
			<Card.Body>
				<Card.Title className='text-center' as='h6'>Current Rate</Card.Title>
				<Row className='text-center'>
					<Col>
						<h4 style={{ color: '#0d6efd' }}>
							{jobsPerMinute.toLocaleString('es-MX', { maximumFractionDigits: 2 })}
						</h4>
						<small className='text-muted'>jobs/min</small>
					</Col>
					<Col>
						<h4 style={{ color: '#6c757d' }}>
							{jobsLastMinutes.toLocaleString('es-MX')}
						</h4>
						<small className='text-muted'>last 5 min</small>
					</Col>
				</Row>
			</Card.Body>
		</Card>
	);
}

StatsCurrentRate.propTypes = {
	rate: PropTypes.object
}

export default StatsCurrentRate;
